import PhotoSwipe from "photoswipe";

const initializePostShowcases = () => {
  const galleries = document.querySelectorAll(
    ".single-post__image-showcase .pswp-gallery"
  );
  if (!galleries.length) {
    return;
  }

  galleries.forEach((galleryElement) => {
    // Prevent initializing the same gallery multiple times
    if (galleryElement.dataset.photoswipeInitialized) {
      return;
    }
    galleryElement.dataset.photoswipeInitialized = "true";

    galleryElement.addEventListener("click", (e) => {
      // Find the clicked anchor tag
      const clickedItem = e.target.closest(".image-showcase__item");
      if (!clickedItem) {
        return;
      }
      e.preventDefault();

      const items = Array.from(
        galleryElement.querySelectorAll(".image-showcase__item")
      );
      const clickedIndex = items.findIndex((item) => item === clickedItem);

      // PhotoSwipe v5 can build the dataSource directly from the gallery elements
      // if they have the correct data attributes (data-pswp-width, data-pswp-height).
      const pswp = new PhotoSwipe({
        dataSource: items,
        index: clickedIndex,
        pswpModule: PhotoSwipe,
      });

      pswp.init();
    });
  });
};

document.addEventListener("DOMContentLoaded", initializePostShowcases);

// Also run if the page is already loaded
if (document.readyState !== "loading") {
  initializePostShowcases();
}
